import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'JDYun 活動系統',
  system_demo: '系統演示',
  confirm: '確認',
  cancel: '取消',
  show: '顯示',
  hide: '隱藏',
  open: '開啟',
  close: '關閉',
  save: '保存',
  edit: '編輯',
  delete: '刪除',
  add: '添加',
  search: '搜索',
  query: '查詢',
  reset: '重置',
  submit: '提交',
  upload: '上傳',
  download: '下載',
  export: '導出',
  import: '導入',

  started: '已開始',
  ended: '已結束',
  next: '下一步',
  prev: '上一步',
  publish: '發布',
  input: '請輸入{text}',
  select: '請選擇{text}',
  total: '共 {total} 條',
  price: '{price} 元',
  required: '{text}為必填項',
  selected: '已選擇 {total} 個{text}',
  create: '新建',
  free: '免費',
  charge: '收費',
  default: '默認',
  custom: '自定義',
  max: '最大',
  min: '最小',
  percent: '百分比',
  online: '線上',
  offline: '線下',
  name: '名稱',
  remark: '備註',
  tips: '溫馨提示',
  header: {
    logout: '退出登錄',
    binding: '綁定賬號',
    mobile: '手機商戶端',
    register: '手機客戶端',
    tips: '活動 {name}',
    qrcodeText: '{name} H5 二維碼',
    qrcodeMiniText: '{name} 小程序碼',
    qrcode: '點擊下載二維碼',
    qrcodeMini: '點擊下載小程序碼'
  },
  home: {
    title: '歡迎使用金豆雲活動管理平台',
    sub_title: '在這裡發布最完整詳細的活動和會議活動',
    desc: '從活動管理開始您的活動舉辦之旅',
    create: '快速創建活動'
  },
  user: {
    title: '賬號基本信息',
    logo: '品牌標誌',
    update: '更新',
    name: '公司或組織名稱',
    short_name: '左上角菜單欄品牌',
    enable: '開啟個性化登錄',
    web_tips: '個性化登錄網址',
    copy: '複製網址',
    login: '登錄頁面品牌名稱',
    login_title: '登錄頁面系統名稱'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // CODE_SUCCESS: 2000,
  2000: '操作請求成功',
  // CODE_ERROR: 5000,
  5000: '網絡請求異常，請檢查網絡',
  // CODE_ERROR_PARAMS: 5001,
  5001: '請求參數錯誤',
  // URL註冊失敗
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'URL註冊失敗',
  // CODE_ERROR_NO_PARAM: 5003,
  5003: '參數錯誤',
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: '權限錯誤',
  // JWT 驗證錯誤
  // CODE_JWT_ERROR: 5100,
  5100: 'JWT 驗證失敗',
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: '登錄失敗',
  // JWT Token 無效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWT 無效',
  // CODE_JWT_NO_USER: 5103,
  5103: '用戶不存在',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'size 參數出錯',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'page 參數出錯',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: '查詢關鍵字出錯'
}



// WEBPACK FOOTER //
// ./src/langs/zh_tw/index.js